import React, { useState } from "react";
import styles from "./chooseResend.module.scss";
import { IoAlertCircleOutline } from "react-icons/io5";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import { RequestVerification } from "@services/newLogin";
import { useRouter } from "next/navigation";
import config from "@config/config";
const RECAPTCHA_SITE_KEY = config.RECAPTCHA_SITE_KEY;
export default function ChangeInfo({ data, user, onSuccess, location, selectedPhoneMethod }) {
  const [error, setError] = useState("");
  const [phone, setPhone] = useState("");
  const [Loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const router = useRouter();
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const isEmailValid = emailRegex.test(email);
  const handlePhoneChange = (value) => {
    setPhone(value);
  };
  const isPhoneValid = phone && isValidPhoneNumber(phone);
  const disable = data.method === "PHONE" ? !isPhoneValid : !isEmailValid;


  const handleSubmit = async () => {
    const to = data.method === "PHONE"? phone : email;
    setLoading(true);
    try {
                const siteKey = RECAPTCHA_SITE_KEY;
    const token = await grecaptcha.enterprise.execute(siteKey, { action: 'login' });   
      const {status, data:validateData} = await RequestVerification(
        {
        recaptchaToken: token,
        method: data.method,
        to: to,
        selectedPhoneMethod: selectedPhoneMethod,
        source: "tickit.co"
      },
      user.idToken
      );
      if(status === 200) {
        console.log(validateData.data);
        
        onSuccess(validateData.data);
      }
    } catch (error) {
      setError(error.response.data.message);
    }
    setLoading(false);
  } 
  return (
    <>
      <div className={styles.overlay}></div>
      <div className={`${styles.container}`}>
        <header className={styles.header}>
          <h2 className={styles.title}>Request a New Code</h2>
        </header>
        {data.method === "PHONE" ? (
          <div className={styles.input}>
            <div className={styles.phone_input}>
              <PhoneInput
                international
                defaultCountry={location.location ? location.countryCode : ""}
                onChange={handlePhoneChange}
                value={phone}
                placeholder="Phone Number"
              />
            </div>
          </div>
        ) : (
          <div className={styles.input}>
            <input
              type="text"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
        )}
        <p className={styles.terms}>By registering you accept our <span onClick={()=> router.push("/legal/terms-of-service")}>Terms of Use</span> and <span onClick={()=> router.push("/legal/privacy-policy")}>Privacy Policy</span></p>
        <div className={styles.submit}>
          <button type="button" disabled={Loading || disable} onClick={handleSubmit}>
            {Loading ? "Sending..." : "Send verification code"}
          </button>
        </div>

        {error.length > 0 && (
          <div
            style={{
              color: "red",
              fontSize: "12px",
              lineHeight: "normal",
              marginTop: "10px",
              display: "flex",
              alignItems: "center",
              gap: "5px",
            }}
          >
            <IoAlertCircleOutline fill="red" style={{ fontSize: "14px" }} />{" "}
            {error}
          </div>
        )}
      </div>
    </>
  );
}
